import { toast } from 'react-hot-toast';

interface SessionNotificationProps {
  type: 'extended' | 'warning' | 'expired';
  message?: string;
}

export const showSessionNotification = ({ type, message }: SessionNotificationProps) => {
  const defaultMessages = {
    extended: 'Sessão estendida com sucesso',
    warning: 'Sua sessão expirará em breve',
    expired: 'Sessão expirada. Você será redirecionado para o login.'
  };

  const finalMessage = message || defaultMessages[type];

  switch (type) {
    case 'extended':
      toast.success(finalMessage, {
        duration: 3000,
        icon: '✅',
      });
      break;
    case 'warning':
      toast(finalMessage, {
        duration: 5000,
        icon: '⚠️',
        style: {
          background: '#fbbf24',
          color: '#1f2937',
        },
      });
      break;
    case 'expired':
      toast.error(finalMessage, {
        duration: 4000,
        icon: '🔒',
      });
      break;
  }
};
